/**
 * Machine-readable failure codes of the pipeline (Spec § 4.3). This is all a
 * `failure_reason` column ever holds: never transcript or draft text, never a
 * provider message. The UI maps the code to copy.
 */
export var AiFailureReason;
(function (AiFailureReason) {
    /** ffprobe found no audio stream in the upload. */
    AiFailureReason["INVALID_AUDIO"] = "invalid_audio";
    /** The upload is longer than the 10-minute cap (plus 5 s tolerance). */
    AiFailureReason["TOO_LONG"] = "too_long";
    /** The provider answered 4xx (other than 408/429): the request itself was wrong. */
    AiFailureReason["PROVIDER_REJECTED"] = "provider_rejected";
    /** The draft still violated Schema v2 / `checkDraft` after the one in-job retry. */
    AiFailureReason["VALIDATION"] = "validation";
    /** The provider returned no usable text. */
    AiFailureReason["EMPTY_TRANSCRIPT"] = "empty_transcript";
    /** Network/timeout/5xx on every Bull attempt. */
    AiFailureReason["TRANSIENT_EXHAUSTED"] = "transient_exhausted";
    /** The sweeper found the run older than `AI_STALE_RUN_MINUTES` (Spec § 4.7). */
    AiFailureReason["STALE"] = "stale";
})(AiFailureReason || (AiFailureReason = {}));
//# sourceMappingURL=ai-failure-reason.enum.js.map